export default "__VITE_ASSET__B5JHKnrJ__"